module.exports = __webpack_public_path__ + "slide7.6433e96de56d7775996e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide7.jpg
// module id = ./src/assets/images/private/home/slide7.jpg
// module chunks = main